import type { FaireProductEntity } from "../../entity_types/product";

export const p_89z7uaa4xx: FaireProductEntity = {
  token: "p_89z7uaa4xx",
  type: "product",
  name: "Double Strand Pearl Necklace",
  brandToken: "b_d5ty4bqhca",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/0fceb0b583a5402498ff4109e5a73a9a220e7dbf3053eec5bc0ef994082c8eca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b314c40df52ed0234b2513e5d840c71390512de079755d3ca77a6a1ee08386aa.jpeg",
    "https://cdn.faire.com/fastly/8e19814fb7e0f9c41f8655fd45359cb70897a5c9a58de8ce45ef6223ba31971a.jpeg",
    "https://cdn.faire.com/fastly/ae6c1c478d0d8855837c6f3ba3f98ba4d827bf2e0edd63001d4ba925ffac730d.jpeg",
    "https://cdn.faire.com/fastly/713338a9b7f5d36947f4e7ecc7954f0bd680d7af9a0eae51644ce2ba410bf96f.jpeg",
    "https://cdn.faire.com/fastly/6de256dea4546b64b60964c9a4f139220757de8e0a49121c7058b7953c0f5e13.jpeg",
  ],
  priceDollars: 25,
  description:
    'This double strand gold necklace features a beautiful champagne colored freshwater pearl. It\'s made with 15" and 16" dainty gold filled 1mm flat drawn cable chains.\n\nFreshwater pearl is approximately 11mm. Please allow for slight variations as each is unique.',
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.295Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
